import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Rendert einen Schema.org-JSON-LD-Block via react-helmet-async in den <head>.
 * Die Daten kommen aus src/seo/clinic.ts (dentistNode, breadcrumbLd, faqLd, …).
 */
export const JsonLd: React.FC<{ data: object }> = ({ data }) => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(data)}</script>
  </Helmet>
);

export default JsonLd;
